'use client';
import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { resolveImageAltText } from '@/lib/utils';

export default function FooterBottomRow({ data }) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    // Ensures window-related logic runs only on the client side
    setIsClient(true);
  }, []);

  function handleOsanoClick(e) {
    if (window?.Osano?.cm) {
      e.preventDefault();
      window.Osano.cm.showDrawer();
    }
  }

  const { image: featureImage, text: featureText } = data?.feature;
  const showFeature = featureImage?.url || featureText;

  return (
    <div className="border-grey-dark mx-4 mt-5 border-t py-5 lg:mx-0">
      <div
        className={`flex flex-col text-center lg:flex-row lg:items-center ${showFeature ? 'lg:justify-between' : 'lg:justify-center'}`}
      >
        <div className="flex flex-col text-center lg:flex-row lg:items-center">
          {data.image && (
            <Image
              src={data.image.url}
              alt={data.image.title.replace(/\.[^/.]+$/, '')}
              width="35"
              height="52"
              sizes="35px"
              className="mx-auto py-2 sm:mx-0 sm:mr-4"
              loading="lazy"
            />
          )}
          <span className="body-xs sm:body-s sm:mr-4">
            &copy; {data.copyright_text} {isClient && new Date().getFullYear()}
          </span>

          <ul className="flex flex-row flex-wrap justify-center text-center">
            {data.items.map((item, index) => {
              if (item.url) {
                return (
                  <li key={index} className="px-2 py-2">
                    <Link
                      href={`${item.url}${item.query_string ?? ''}`}
                      prefetch={false}
                      className="body-s"
                    >
                      {item.label}
                    </Link>
                  </li>
                );
              }
              return null;
            })}
            {isClient && window?.Osano?.cm && (
              <li
                className="body-s cursor-pointer self-center px-2 py-2"
                onClick={(e) => handleOsanoClick(e)}
              >
                Do Not Sell or Share My Personal Information
              </li>
            )}
          </ul>
        </div>
        {showFeature && (
          <div className="mt-8 mb-5 lg:mt-0 lg:mb-5">
            {featureImage?.url && (
              <div className="relative mx-auto mb-1 h-12.5 w-full">
                <Image
                  src={featureImage.url}
                  alt={resolveImageAltText(featureImage)}
                  fill
                  className="object-contain"
                  sizes="300px"
                />
              </div>
            )}
            {featureText && <div className="body-xs">{featureText}</div>}
          </div>
        )}
      </div>
    </div>
  );
}
